module.exports = __webpack_public_path__ + "static/about-us-model-photo@2x-71243c57c5229bccf1f1973f0834c11f.jpg";